export default __webpack_public_path__ + "static/media/271.19b4d1bd.jpg";